import api from './url'
import axios from 'axios'

const getBrands = async () => await axios.get(api.getBrandsApi())

const getModels = async ({payload}) => {
    return await axios.get(api.getModelsApi(), {
        params: {
            brand: payload
        }
    })
}

const getYears = async ({payload}) => {
    return await axios.get(api.getYearsApi(), {
        params: {
            brand: payload.brand,
            model: payload.models
        }
    })
}

const registerGocarSimple = async payload => {
    return await axios.post(api.registerGocarSimple(), payload)
}

export default {
    registerGocarSimple,
    getBrands,
    getModels,
    getYears
}


// WEBPACK FOOTER //
// ./src/helpers/api.js